// Format --> BZC + hash + timestamp + counter + randomness
// USE CASE in PAI Folder use  const id = await generateUniqueId();
//in component use generateUniqueId().then(id => console.log(id));
let counter = 0;
export async function generateUniqueId() {
  const prefix = "BZC";
  const timestamp = Date.now(); // milliseconds since epoch
  const random = crypto.getRandomValues(new Uint32Array(1))[0]; // secure random
  counter++;

  const raw = `${timestamp}-${random}-${counter}`;
  const encoder = new TextEncoder();
  const data = encoder.encode(raw);

  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  const uniquePart = hashHex.slice(0, 8).toUpperCase(); // e.g. 8-char unique suffix
  return prefix + uniquePart;
}

export function generateTimestampId() {
  const prefix = "BZC";
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Jan is 0
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const timestamp = `${year}${month}${day}${hours}${minutes}${seconds}`;
  return prefix + timestamp;
}

export const sanitizeFileName = (name) => {
  const cleaned = name
    .replace(/[^\w.-]/g, "_") // Replace invalid chars with _
    .replace(/_+/g, "_"); // Collapse multiple underscores
  return cleaned;
};
